import React from 'react'

// --- utils to normalize holes and build rounded paths ---
const toNum = (v) => (typeof v === 'number' && Number.isFinite(v) ? v : NaN)
const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v))

const MaskSvg = ({rects, zIndex, onClick}) => {
    const vw = window.innerWidth,
        vh = window.innerHeight
    const normRect = (r) => {
        if (!r) return null
        const left = toNum(r.left),
            top = toNum(r.top)
        let width = r.width != null ? toNum(r.width) : r.right != null ? toNum(r.right) - left : NaN
        let height = r.height != null ? toNum(r.height) : r.bottom != null ? toNum(r.bottom) - top : NaN
        if (!Number.isFinite(left) || !Number.isFinite(top) || !Number.isFinite(width) || !Number.isFinite(height))
            return null
        const L = clamp(left, 0, vw),
            T = clamp(top, 0, vh)
        const W = Math.max(0, Math.min(width, vw - L))
        const H = Math.max(0, Math.min(height, vh - T))
        if (W === 0 || H === 0) return null
        // radius can be number or {tl,tr,br,bl}
        const rad = normalizeRadius(r.radius, W, H)
        return {left: Math.round(L), top: Math.round(T), width: Math.round(W), height: Math.round(H), radius: rad}
    }
    function normalizeRadius(radius = 0, w, h) {
        if (radius === 0) return 0
        const halfW = w / 2,
            halfH = h / 2

        if (radius === null) return {tl: 8, tr: 8, br: 8, bl: 8}
        if (typeof radius === 'number') {
            const r = Math.min(radius, halfW, halfH)
            return {tl: r, tr: r, br: r, bl: r}
        }
        // object per-corner
        const tl = Math.min(toNum(radius.tl ?? radius.topLeft ?? 0) || 0, halfW, halfH)
        const tr = Math.min(toNum(radius.tr ?? radius.topRight ?? 0) || 0, halfW, halfH)
        const br = Math.min(toNum(radius.br ?? radius.bottomRight ?? 0) || 0, halfW, halfH)
        const bl = Math.min(toNum(radius.bl ?? radius.bottomLeft ?? 0) || 0, halfW, halfH)
        return {tl, tr, br, bl}
    }
    function roundedSubpath({left: x, top: y, width: w, height: h, radius: r}) {
        // build a rounded-rect path (clockwise), using arc commands
        if (!r) return `M${x} ${y} H${x + w} V${y + h} H${x} Z`
        const d = [
            `M${x + r.tl} ${y}`,
            `H${x + w - r.tr}`,
            `a ${r.tr} ${r.tr} 0 0 1 ${r.tr} ${r.tr}`,
            `V${y + h - r.br}`,
            `a ${r.br} ${r.br} 0 0 1 ${-r.br} ${r.br}`,
            `H${x + r.bl}`,
            `a ${r.bl} ${r.bl} 0 0 1 ${-r.bl} ${-r.bl}`,
            `V${y + r.tl}`,
            `a ${r.tl} ${r.tl} 0 0 1 ${r.tl} ${-r.tl}`,
            'Z',
        ].join(' ')
        return d
    }
    const holes = (rects ?? []).map(normRect).filter(Boolean)
    const roundedPath = [`M0 0 H${vw} V${vh} H0 Z`, ...holes.map(roundedSubpath)].join(' ')

    // const path = [
    //     `M0 0 H${vw} V${vh} H0 Z`,
    //     ...(rects ?? []).map((r) => `M${r.left} ${r.top} H${r.left + r.width} V${r.top + r.height} H${r.left} Z`),
    // ].join(' ')

    return (
        <svg width={vw} height={vh} style={{position: 'fixed', inset: 0, zIndex, pointerEvents: 'none'}} aria-hidden>
            <path
                d={roundedPath}
                fill="rgba(0,0,0,0.5)"
                fillRule="evenodd"
                style={{pointerEvents: 'auto'}}
                onClick={onClick}
            />
        </svg>
    )
}

export default MaskSvg
